import { authIsLoggedIn } from './AuthStore';

export const updateAuthIsLoggedIn = (value) => authIsLoggedIn.update((oldValue) => value);
